import { enums as e, Tooltip } from 'edrolo-ui';
import s from './styles.scss';
import cx from 'classnames';

interface Value {
  number: number;
  color: e.ColorHue | e.ColorTheme;
  title?: string;
}

export interface MultiProps {
  values: Value[];
  size?: e.Size;
  className?: string;
}

export const Multi = ({
  values,
  size = e.Size.MEDIUM,
  className,
}: MultiProps) => {
  const calculatePercentages = (values: Value[]): Value[] => {
    const total = values.reduce((sum, value) => sum + value.number, 0);
    return values.map((value) => ({
      ...value,
      number: (value.number / total) * 100,
    }));
  };

  const percentageValues = calculatePercentages(values);

  return (
    <div
      className={cx(s.progressMulti, s[size], className)}
      aria-label="progress-status"
    >
      {percentageValues.map(({ number, color, title }, i) => (
        <Tooltip key={i} tip={title}>
          <div
            className={cx(s.fill, s[size], s[color])}
            style={{ width: `${number}%` }}
          />
        </Tooltip>
      ))}
    </div>
  );
};
